type Props = {
    children: React.ReactNode;
};

/** Portal Lab is open to all authenticated users (route still sits behind RequireAuth). */
const RequirePortalLabAccess = ({ children }: Props) => <>{children}</>;

export default RequirePortalLabAccess;
